import React from 'react';
import { cn } from '@/utils/cn';
import { getImageUrl } from '@/utils/string';
import { imageTypes } from '@/constants/types';
import ImageComponentV2 from '../Image/ImageComponentV2';

function ImagePlaceholderBadge({ imageSrc = '' }) {
  return (
    <div
      className={cn(
        'w-[48px] lg:w-[64px] h-[60px] lg:h-[80px] flex justify-center items-center rounded-8 shadow-badge-image-placeholder',
        {
          'bg-aquarelle-purple': !imageSrc,
        },
      )}
    >
      {imageSrc ? (
        <ImageComponentV2
          src={imageSrc ? getImageUrl(imageSrc) : null}
          alt="placeholder-badge"
          className="w-full h-full max-w-full object-fill rounded-8"
          height={600}
          width={560}
          type={imageTypes.tall}
          loading="lazy"
        />
      ) : (
        <p className="text-[6px] lg:text-[8px] text-black font-bold text-center">
          Image
          <br /> Placeholder
          <br /> 64x80
        </p>
      )}
    </div>
  );
}

export default ImagePlaceholderBadge;
